import { createAsyncThunk } from '@reduxjs/toolkit';
import { DefaultWellTestData } from '../types/wellTestTypes';
import { fetchDefaultWellTestData } from '../services/dashboard/DefaultWellTestService';

export const fetchDefaultWellTestDataAsync = createAsyncThunk<{ values: DefaultWellTestData[] } | null, string>(
  'wellTest/fetchDefaultWellTestData',
  async (assetId: string, { signal }) => {
    try {
      const response = await fetchDefaultWellTestData(assetId, signal);
      return response;
    } catch (error) {
      console.error('Error fetching Default well test data:', error);
      return null;
    }
  },
  {
    condition: (assetId, { getState }) => {
      const state = getState() as any;
      const isLoading = state.DefaultWellTest?.loading;
      const currentAssetId = state.DefaultWellTest?.currentAssetId;

      if (currentAssetId && currentAssetId !== assetId) {
        return true;
      }

      if (currentAssetId === assetId) {
        return !isLoading;
      }

      return !isLoading;
    },
  },
);
